import { Identifier } from '@core/models/common/identifier';

export const DEFAULT_LAT: number = -28.024;
export const DEFAULT_LNG: number = 140.887;
export const DEFAULT_ZOOM: number = 12;

export const ICON_MARKER_RED = 'assets/img/map-pin-red.svg';
export const ICON_MARKER_GREEN = 'assets/img/map-pin-green.svg';
export const ICON_MARKER_BLACK = 'assets/img/map-pin-black.svg';
export const ICON_MARKER_ORANGE = 'assets/img/map-pin-orange.svg';
export const ICON_MARKER_WARNING = 'assets/img/map-pin-warning.svg';

export interface LatLng {
    lat: number;
    lng: number;
}

export interface MarkerLabel {
    text: string;
    className?: string;
    color?: string;
}

export interface MapMarker extends Identifier {
    tooltip?: string;
    latLng: LatLng;
    iconMarkerUrl?: string;
    label?: string | MarkerLabel;
    badge?: string;
    scaledSize?: {
        width: number;
        height: number;
    };
    anchor?: {
        x: number;
        y: number;
    };
    zIndex?: number;
    tooltipClass?: string;
}
